import { Property } from "@shared/interfaces/Property";
import { County } from "@shared/models/County";
import { State } from "@shared/models/State";
import { Account } from "@shared/models/Account";
import { LeadErrorReason } from "@containers/PayPerLead/interface";

export enum PayPerLeadResolution {
  approved = "approved",
  rejected = "rejected",
}

export interface PayPerLeadDispute {
  id: number;
  lead_id: number;
  message: string;
  created_at: Date;
  created_by?: string | null;
  resolved_date?: Date | string | null;
  resolved_by?: string | null;
  resolution: PayPerLeadResolution | null;
  resolution_comment?: string | null;
  is_active: boolean;
  photos: { path: string }[];
  lead: Partial<PayPerLead>;
}

export interface LeadForwardingPartner {
  id: number;
  code_name: string;
  is_active: boolean;
}

export enum LeadForwardingStatus {
  Pending = "pending",
  Accepted = "accepted",
  Rejected = "rejected",
}

export interface LeadForwarding {
  id: number;
  lead_id: number;
  partner_id: number;
  status: LeadForwardingStatus;
  status_reason: string;
  partner?: LeadForwardingPartner;
}

enum ClickSource {
  Facebook = "facebook",
  Google = "google",
  Bing = "bing",
}

export interface LeadSessionTracking {
  id: number;
  address: string;
  phone: string;
  email: string;
  click_id?: string;
  created_at?: Date;
  click_source?: ClickSource;
  campaign?: string;
  property?: Property;
  termination_reason?: LeadErrorReason;
  status?: string;
  lead?: PayPerLeadWithDetail;
  state?: State;
  county?: County;
  consent_text?: string;
  user_agent?: string;
  ip_address?: string;
  source?: string;
  name?: string;
  sell_timeline?: string;
}

export interface PayPerLead {
  id: number;
  name: string;
  address: string;
  long_address: string;
  phone: string;
  email: string;
  account_id: number;
  account?: Account;
  subscription_id: number;
  city: string;
  state_id: number;
  state?: State;
  county_id: number;
  county: County;
  price: number;
  is_active: boolean;
  property_type: string;
  occupied: string;
  listed_by_realtor: boolean;
  sell_timeline: string;
  legal_owner?: string;
  contacted_by?: string;
  sell_reason: string;
  condition?: string;
  created_at: Date;
  updated_at: Date;
  dispute?: PayPerLeadDispute;
  is_qualified: boolean | null;
  source: string;
  property_id?: number;
  forwarding?: LeadForwarding;
  session?: LeadSessionTracking | null;
}

export interface PayPerLeadWithDetail extends PayPerLead {
  detail: Property | null;
}
